(() => {
  const root = document.documentElement;
  const body = document.body;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateHeader = () => {
    body.classList.toggle('doggy-has-scrolled', window.scrollY > 24);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const reveal = () => {
    const elements = document.querySelectorAll('.doggy-reveal:not([data-doggy-ready])');
    if (!elements.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.doggyReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
    );

    elements.forEach((element, index) => {
      element.dataset.doggyReady = 'true';
      element.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(element);
    });
  };

  reveal();
  document.addEventListener('shopify:section:load', reveal);
  document.addEventListener('shopify:section:reorder', reveal);

  const setupStickyProduct = () => {
    const mainButton = document.querySelector('main[data-template="product"] .product-form__submit[name="add"]');
    const productForm = mainButton?.closest('product-form');
    const productInfo = mainButton?.closest('.product__info-container');
    const productInfoWrapper = mainButton?.closest('.product__info-wrapper');
    if (!mainButton || !productForm || !productInfo || !productInfoWrapper || productForm.dataset.doggyReady === 'true') return;

    productForm.dataset.doggyReady = 'true';
    const triggerTop = mainButton.getBoundingClientRect().top + window.scrollY + mainButton.offsetHeight;

    const updateStickyProduct = () => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const infoIsVisible = productInfo.getBoundingClientRect().bottom > 120;
      const isActive = isMobile && window.scrollY > triggerTop && infoIsVisible;
      productForm.classList.toggle('doggy-native-sticky-active', isActive);
      productInfoWrapper.classList.toggle('doggy-native-sticky-context', isActive);
      body.classList.toggle('doggy-sticky-product-visible', isActive);
    };

    updateStickyProduct();
    window.addEventListener('scroll', updateStickyProduct, { passive: true });
    window.addEventListener('resize', updateStickyProduct);
  };

  setupStickyProduct();
  document.addEventListener('shopify:section:load', setupStickyProduct);

  root.classList.add('doggy-js');
})();
